import React, {useState, useEffect} from 'react';
import queryString from 'query-string';
import ScrollToBottom from 'react-scroll-to-bottom';
import io from 'socket.io-client';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import IconButton from '@material-ui/core/IconButton';
import Container from '@material-ui/core/Container';
import CssBaseline from '@material-ui/core/CssBaseline';
import InputAdornment from '@material-ui/core/InputAdornment';
import Input from '@material-ui/core/Input';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import { makeStyles, ThemeProvider } from '@material-ui/core/styles';
import {themeDark} from './Login';
import NavBar from './NavBar';
import Message from './Message';
import Footer from './Footer';
import Wallpaper from '../images/wallpaper.jpg';

const useStyles = makeStyles((theme) => ({
  container: {
  },
  paper: {
    margin: theme.spacing(8,0),
    backgroundImage: `url(${Wallpaper})`,
    backgroundSize: '100% 100%',
    display: 'flex',
    flexDirection: 'column',
    height: 750,
    position: 'relative',
  },
  icon: {
    margin: theme.spacing(1),
    width: 20,
    height: 20,
  },
  sendIcon: {
    margin: theme.spacing(1),
    width: 20,
    height: 20,
    color: '#03a9f4',
  },
  messages:{
    overflow: 'auto',
    flex: 'auto',
    marginBottom: theme.spacing(9),
    paddingTop: '0.5%',
  },
  textField: {
    padding: theme.spacing(4.5,2),
    marginTop: theme.spacing(3),
    height: 60,
    bottom: 0,
    color: 'black',
    backgroundColor: 'white',
    position: 'absolute',
  },
}));

// const ENDPOINT = 'http://localhost:5000';
const ENDPOINT = "https://project-anonymous-boris.herokuapp.com";
let socket;

export default function Chat ( {location} ) {

  const classes = useStyles();
  const [name, setName] = useState('');
  const [message, setMessage] = useState('');
  const [messages, setMessages] = useState([]);
  const [allUsers, setAllUsers] = useState();

  useEffect(()=>{
    const {name, token} = queryString.parse(location.search);
    setName(name);
    socket = io(ENDPOINT);
    socket.emit('join', {name, token});
  },[location.search]); 

  useEffect(()=>{
    socket.on('message', message => {
      setMessages(messages => [ ...messages, message ]);
    });
    socket.on("roomData", ({users}) => {
      setAllUsers(users);
    });
  },[]);

  const sendMessage = (e) => {
    e.preventDefault();
    if(message) {
      socket.emit('sendMessage', message, () => setMessage(''));
    }
  }

  return(
    <ThemeProvider theme = {themeDark}>
    <Container component="main" maxWidth="sm" className={classes.container}>
      <CssBaseline />
      <Paper>
        <div className={classes.paper} id="messages">
          <NavBar users={allUsers}/>
          <ScrollToBottom className={classes.messages}>
            {messages.map((message, i) => <div key={i}><Message message={message} name={name}/></div>)}
          </ScrollToBottom>
          <Input
            autoFocus
            className={classes.textField}
            multiline
            fullWidth
            type="text"
            autoComplete='on'
            required
            rows='1'
            rowsMax='3'
            value={message}
            placeholder='Text Message'
            onKeyPress={event => event.key === 'Enter' ? sendMessage(event) : null}
            onChange={({ target: { value } }) => setMessage(value)}
            endAdornment = {       
            <InputAdornment position="end">
              <IconButton edge="end" onClick={(e) => sendMessage(e)}>
                <ArrowUpwardIcon className={classes.sendIcon}/>
              </IconButton>
            </InputAdornment>
            }
          />
        </div>
      </Paper>
      <Box mt={5}>
        <Footer />
      </Box>
     </Container>
    </ThemeProvider>
  );
}